import { useState } from 'react'

export const useForm = <T extends Object>(initState: T | null) => {
    const [state, setState] = useState(initState)

    const onChange = <K extends Object>(value: K, field: keyof T | any) => {
        // El type ahora es generico, tiene que ser distinto de T

        setState({
            ...state,
            [field]: value,
        })
    }

    return {
        ...state,
        form: state,
        onChange,
    }
}
